import { render, staticRenderFns } from "./IndexV2.vue?vue&type=template&id=2eec6cde&"
import script from "./IndexV2.vue?vue&type=script&lang=js&"
export * from "./IndexV2.vue?vue&type=script&lang=js&"
import style0 from "./IndexV2.vue?vue&type=style&index=0&id=2eec6cde&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports